import PowerVideos from './PowerVideos.jsx';
import './styles/Power.scss';
import first from '../videos/2_1.mp4';
import second from '../videos/2.2.mp4';
import third from '../videos/2_3.mp4';
import fourth from '../videos/2.4.mp4';



function Paribus() {


    return (
        <section className="power" id="paribus">
          <div className="cardWrapper">
            <PowerVideos src={first}>Cheap <br />transactions</PowerVideos>
            <PowerVideos src={second}>Incredibly high <br />throughput</PowerVideos>
            <PowerVideos src={third}>Security and reliability for high-value transfers</PowerVideos>
            <PowerVideos src={fourth}>A flourishing development and dApp ecosystem</PowerVideos>
          </div>
          <div className="powerText">
            <h2 className="firstTitle subtitle colorGradientBlue">
              The Power of Paribus <br />
              Powered by Cardano
            </h2>
            <h2 className="titleH2 firstText">Connecting the Dots</h2>
            <p className="desc1 firstText">
              Cardano will allow the Paribus protocol to remain chain agnostic
              and simultaneously connect innumerable assets across multiple
              blockchains. We are interested in working with the most promising
              teams developing new ways to create and store value, regardless of
              where they decide to develop.<br />
            </p>
            <p className="desc1 firstText">
              Cardano’s interoperability removes the restrictions imposed by a
              siloed ecosystem and allows value to flow freely, increasing
              opportunity for the protocol and it’s users.
            </p>
          </div>
        </section>
    )
}
            
export default Paribus;